import { render } from "./OutputItem.vue?vue&type=template&id=848c1052"
import script from "./OutputItem.vue?vue&type=script&lang=js"
export * from "./OutputItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__